import { NewsReleases } from './newsReleases'

export { NewsReleases }
